import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { GetProductsQuery } from '@core/services/api.service';
import { AuthState } from '@ngxs-store/auth-store/auth.state';
import { Store } from '@ngxs/store';

@Component({
    selector: 'app-shared-store-sort',
    templateUrl: './shared-store-sort.component.html',
    styleUrls: ['./shared-store-sort.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class StoreSortComponent implements OnChanges {
    @Input() pageSize: number;
    @Input() pageSortBy: string;
    @Output() sortPageResultSize = new EventEmitter<any>();
    @Output() sortByPage = new EventEmitter<any>();
    pageSizes: number[];
    selectedSize: number;
    selectedSortBy: string;
    hasValidToken = false;
    constructor(public store: Store) {
        this.hasValidToken = this.store.selectSnapshot(AuthState.getHasValidToken);
        this.pageSizes = [16, 32, 64, 100];
        this.selectedSize = 16;
        this.selectedSortBy = "Default"
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.pageSize && changes.pageSize.currentValue) {
            this.selectedSize = this.pageSize;
        }

        if (changes.pageSortBy && changes.pageSortBy.currentValue) {
            this.selectedSortBy = this.pageSortBy;
        }
    }

    updatePageResultSize() {
        this.sortPageResultSize.emit(this.selectedSize);
    }

    updatePageSortBy() {
        this.sortByPage.emit(this.selectedSortBy);
    }
}

